import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField
} from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useStyles } from './styles'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import { ISearchOTInbound } from '../../interfaces/Planner/Planner'
import {
  useTypeAsnDocument,
  useWarehouses,
  useSuppliers,
  useAsnState
} from '../../hooks'
import { apiCall, ApiConfig } from '../../config/api'
import { SupplierOrigin } from '../../interfaces'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { usePriority } from '../../hooks/usePriority'

interface ASNSearchProps {
  search: ISearchOTInbound
  handleSearch: any
  handleSearchSecondary: any
  handleResetBusqueda: any
  handleFetchFilteredData: any
  handleGetOt: () => void
}

interface Option {
  key: string | number
  value: string | number
}

export const SearchOtInbound: React.FC<ASNSearchProps> = ({
  search,
  handleSearch,
  handleSearchSecondary,
  handleResetBusqueda,
  handleFetchFilteredData,
  handleGetOt
}) => {
  const classes = useStyles()

  const [renderInput, setRenderInput] = useState<string>('')
  const [isSelect, setSelect] = useState<boolean>(false)
  const [dateValue, setDateValue] = useState({
    initialDate: '',
    FinalCreatedDate: ''
  })

  const handleDate = (e: any, name: string) => {
    setDateValue({
      ...dateValue,
      [name]: e
    })
  }

  const { isPriority } = useSelector((state: RootState) => state.otInbound)

  const [array, setArray] = useState<Option[] | undefined>([])
  const [disabled, setDisabled] = useState<boolean>(false)
  const [addInput, setAddInput] = useState<boolean>(false)
  const [isSupplier, setIsSupplier] = useState<boolean>(false)
  const [isRangeDate, setIsRangeDate] = useState<boolean>(false)
  const [origin, setOrigin] = useState<SupplierOrigin[]>([])
  const [originFiltered, setOriginFiltered] = useState<SupplierOrigin[]>([])

  const {
    typeAsnDocumentState: { typeAsnDocument },
    getTypeAsnDocument
  } = useTypeAsnDocument()
  const {
    suppliersState: { suppliers },
    getSuppliers
  } = useSuppliers()

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  const handleCallHook = (endpointCall: string) => {
    let arraySet: Option[] | undefined = []
    if (endpointCall === 'WarehouseId') {
      arraySet =
        typeAsnDocument?.length === 0
          ? []
          : warehouses?.map((x) => ({
              key: x.id,
              value: x.warehouseName
            }))
      setArray(arraySet)
    } else if (endpointCall === 'Supplier') {
      arraySet =
        suppliers?.length === 0
          ? []
          : suppliers?.map((x) => ({
              key: x.supplierId,
              value: x.supplierName
            }))
      setArray(arraySet)
    } else if (endpointCall === 'AsnStateId') {
      arraySet =
        asnState?.length === 0
          ? []
          : asnState?.map((x) => ({
              key: x.asnStateId,
              value: x.name
            }))
      setArray(arraySet)
    }
  }

  const getFilteredOrigins = (id: number) => {
    setOriginFiltered(origin.filter((e) => e.supplierId === id))
  }

  const {
    asnStatesState: { asnState },
    getAsnState
  } = useAsnState()

  const getOrigins = async () => {
    const response = await apiCall(
      'GET',
      `${ApiConfig.SupplierOriginApi}?pageSize=500`
    )
    setOrigin(response.data.items)
  }

  const handleApiCallDataItems = (
    typeComponent: string,
    endpointCall: string
  ) => {
    search.searchValue = ''
    if (
      typeComponent === 'text' ||
      typeComponent === 'number' ||
      typeComponent === 'datetime-local'
    ) {
      if (endpointCall === 'rangeDate') {
        setAddInput(true)
        setIsSupplier(false)
        setIsRangeDate(true)
        setRenderInput(typeComponent)
        setSelect(false)
        setDisabled(false)
      } else {
        setIsRangeDate(false)
        setIsSupplier(false)
        setAddInput(false)
        setRenderInput(typeComponent)
        setSelect(false)
        setDisabled(false)
      }
    } else {
      if (typeComponent === 'select') {
        if (endpointCall === 'Supplier') {
          setAddInput(true)
          setIsSupplier(true)
          setIsRangeDate(false)
          if (origin?.length === 0) {
            getOrigins()
          }
          handleCallHook(endpointCall)
          setRenderInput(typeComponent)
          setSelect(true)
          setDisabled(false)
        } else {
          setAddInput(false)
          setIsRangeDate(false)
          setIsSupplier(false)
          handleCallHook(endpointCall)
          setRenderInput(typeComponent)
          setSelect(true)
          setDisabled(false)
        }
      } else {
        setAddInput(false)
        setIsRangeDate(false)
        setIsSupplier(false)
        setRenderInput('')
        setSelect(false)
        setDisabled(true)
      }
    }
  }

  const { enablePriority, disabledPriority } = usePriority()

  const onChangeDate = (value: any, name: string) => {
    handleSearchSecondary(name, new Date(value).toISOString().split('Z')[0])
    handleDate(value, name)
  }

  const priorizar = () => {
    if (isPriority) {
      disabledPriority()
    } else {
      enablePriority()
    }
    handleGetOt()
  }

  useEffect(() => {
    if (typeAsnDocument?.length === 0) {
      getTypeAsnDocument()
    }
    if (asnState?.length === 0) {
      getAsnState()
    }
    if (suppliers?.length === 0) {
      getSuppliers()
    }
    if (warehouses?.length === 0) {
      getWarehouses()
    }
    getOrigins()
  }, [])

  return (
    <Paper elevation={2} className={classes.searchBar}>
      <Grid container spacing={4} direction='row' alignItems='center'>
        <Grid
          item
          xs={12}
          sm={addInput ? 3 : 6}
          md={3}
          className={classes.input}
        >
          <TextField
            id='searchField'
            name='searchField'
            label='Buscar por'
            select
            fullWidth
            value={search.searchField}
            onChange={handleSearch}
          >
            <MenuItem
              value={'AsnNumber'}
              onClick={() => handleApiCallDataItems('text', '')}
            >
              ID ASN
            </MenuItem>
            <MenuItem
              value={'WorkOrderCode'}
              onClick={() => handleApiCallDataItems('text', '')}
            >
              ID de OT
            </MenuItem>
            <MenuItem
              value={'InitialCreatedDate'}
              onClick={() =>
                handleApiCallDataItems('datetime-local', 'rangeDate')
              }
            >
              Rango de fecha de creación
            </MenuItem>
            <MenuItem
              value={'SupplierId'}
              onClick={() => handleApiCallDataItems('select', 'Supplier')}
            >
              Proveedor/Origen
            </MenuItem>

            <MenuItem
              value={'AsnStateId'}
              onClick={() => handleApiCallDataItems('select', 'AsnStateId')}
            >
              Estado
            </MenuItem>
            <MenuItem
              value={'WarehouseId'}
              onClick={() => handleApiCallDataItems('select', 'WarehouseId')}
            >
              Almacén
            </MenuItem>
            <MenuItem
              value={'Mostrar Todas'}
              onClick={() => handleApiCallDataItems('', '')}
            >
              Mostrar Todas las OT
            </MenuItem>
          </TextField>
        </Grid>

        <Grid
          item
          xs={12}
          sm={addInput ? 3 : 6}
          md={3}
          className={classes.input}
        >
          <TextField
            id='searchValue'
            name='searchValue'
            label={
              isSupplier
                ? 'Proveedor'
                : isRangeDate
                ? 'Desde'
                : 'Valor a buscar'
            }
            onChange={(e) => {
              isRangeDate
                ? onChangeDate(e.target.value, 'initialDate')
                : handleSearch(e)
            }}
            value={isRangeDate ? dateValue.initialDate : search.searchValue}
            fullWidth
            InputLabelProps={{
              shrink: true
            }}
            type={renderInput}
            select={isSelect}
            style={{ display: disabled ? 'none' : 'inline-block' }}
          >
            {array?.map((x) => {
              return (
                <MenuItem
                  value={x.key}
                  onClick={() => {
                    getFilteredOrigins(Number(x.key))
                  }}
                >
                  {x.value}
                </MenuItem>
              )
            })}
          </TextField>
        </Grid>

        {addInput && (
          <Grid item xs={12} sm={3} md={3} className={classes.input}>
            <TextField
              id='searchValueSecondary'
              name='searchValueSecondary'
              label={isSupplier ? 'Origen' : 'Hasta'}
              onChange={(e) => {
                isSupplier
                  ? handleSearchSecondary('SupplierOriginId', e.target.value)
                  : onChangeDate(e.target.value, 'FinalCreatedDate')
              }}
              value={
                isRangeDate
                  ? dateValue.FinalCreatedDate
                  : search.searchValueSecondary
              }
              fullWidth
              InputLabelProps={{
                shrink: true
              }}
              type={renderInput}
              select={isSelect}
              style={{ display: disabled ? 'none' : 'inline-block' }}
            >
              {originFiltered?.map((x) => {
                return <MenuItem value={x.id}>{x.supplierOriginName}</MenuItem>
              })}
            </TextField>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          sm={addInput ? 3 : 6}
          md={3}
          style={{ textAlign: 'right' }}
        >
          <IconButton
            color='primary'
            onClick={() => {
              handleResetBusqueda()
              setDateValue({
                initialDate: '',
                FinalCreatedDate: ''
              })
              setDisabled(false)
            }}
          >
            <RotateLeftIcon />
          </IconButton>
          <Button
            variant='contained'
            color='primary'
            onClick={handleFetchFilteredData}
            style={{ marginLeft: 10 }}
          >
            Buscar
          </Button>
        </Grid>

        <Grid item xs={12} sm={2} md={2} style={{ textAlign: 'left' }}>
          <Button
            variant='contained'
            color='primary'
            onClick={priorizar}
            style={{ marginLeft: 10 }}
          >
            {isPriority ? 'Terminar Priorización' : 'Priorizar'}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  )
}
